import { LogFetchParam, LogListResponse, SendLogParam } from '@@types/Api/Log';
import Log from '@@types/Log';

import { URLS } from '~/constants';
import { LOG_SEND_TIMEOUT } from '~/constants/api';
import InterTenantApi from '~/stores/providers/InterTenantApi';
import { isMainView } from '~/utils/runEnvironmentUtil';

class InterTenantLogApi {
  constructor(private api: InterTenantApi) {}

  fetchLogs = ({ channelId, ...params }: LogFetchParam): Promise<LogListResponse> => {
    return this.api.dataRequester.cancelGet(`${URLS.V4_API}/channels/${channelId}/logs`, channelId, {
      params: { limit: 50, setLastChannel: isMainView(), ...params },
    });
  };

  sendLog = ({ channelId, text, token }: SendLogParam): Promise<Log> => {
    return this.api.resultRequester.post(
      `${URLS.V4_API}/channels/${channelId}/logs`,
      { text, token },
      { timeout: LOG_SEND_TIMEOUT }
    );
  };
}

export default InterTenantLogApi;
